import { reset_vars_css } from './utils/vars'
import { detect_browser } from './utils/browser'
import { global_vars } from './utils/globalVars'
import { resizeCallback } from './utils/resize'
import { scroll } from './utils/scroll'
import { initCookies } from './components/cookieconsent'
import { menu } from './components/header'
import { modal } from './components/modal'
import { initClock } from './components/clock'

import.meta.glob([
    '../images/**',
    '../fonts/**',
])

document.addEventListener('DOMContentLoaded', () => {
    detect_browser();
    initCookies();
    menu.init();
    modal.init();
    initClock();
});

// ⏱️ después del primer paint real
window.addEventListener('load', () => {
    requestAnimationFrame(() => {
        reset_vars_css();
        global_vars();
        scroll.init();
    });

    window.addEventListener('resize', resizeCallback);
});
